import { Injectable } from '@angular/core';
import { isCheckoutRoute, isOrderConfirmationRoute } from '@checkout/utils';
import { CustomRouterStateSnapshot } from '@core/const';
import { EnvironmentService } from '@core/feature';
import { Actions, EffectNotification, OnRunEffects, createEffect, ofType } from '@ngrx/effects';
import {
  ROUTER_NAVIGATED,
  ROUTER_REQUEST,
  RouterNavigatedAction,
  RouterNavigatedPayload,
  RouterRequestAction,
  RouterRequestPayload,
} from '@ngrx/router-store';
import { CustomOrder } from '@order/const';
import { RoutingService } from '@spartacus/core';
import { EMPTY, Observable, iif } from 'rxjs';
import { delay, filter, map, switchMap, take } from 'rxjs/operators';
import { CustomCheckoutService } from '../services';

@Injectable()
export class OrderConfirmationEffects implements OnRunEffects {
  routerRequestFromOrderConfirmation$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ROUTER_REQUEST),
        map((routerRequestAction: RouterRequestAction) => routerRequestAction.payload),
        filter(
          ({ routerState, event }: RouterRequestPayload<CustomRouterStateSnapshot>) =>
            isOrderConfirmationRoute(routerState.semanticRoute) && !event.url.includes('order-confirmation'),
        ),
        delay(2500),
        map(() => {
          this.customCheckoutService.clearPlaceOrderState();
        }),
      ),
    { dispatch: false },
  );

  routerRequestToCheckout$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ROUTER_NAVIGATED),
        map((action: RouterNavigatedAction) => action.payload),
        filter(({ routerState }: RouterNavigatedPayload<CustomRouterStateSnapshot>) =>
          isCheckoutRoute(routerState.semanticRoute),
        ),
        map(() => {
          this.customCheckoutService.clearPlaceOrderState();
        }),
      ),
    { dispatch: false },
  );

  orderConfirmationNavigated$: Observable<void> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ROUTER_NAVIGATED),
        map((routerRequestAction: RouterRequestAction) => routerRequestAction.payload),
        filter((pld: RouterRequestPayload<CustomRouterStateSnapshot>) =>
          isOrderConfirmationRoute(pld.routerState.semanticRoute),
        ),
        map(() => {
          this.customCheckoutService.waitForRedirectToOrderConfirmationPage$.next(false);
          //  успешная оплата редиректит сразу на страницу спасибо мимо гварда в чекауте.
          this.customCheckoutService.setRedirectedToPaymentPage(false);
        }),
        delay(500),
        switchMap(() => this.customCheckoutService.getOrderDetails().pipe(take(1))),
        map((order: CustomOrder) => {
          if (!order.code) {
            this.routingService.go({ cxRoute: 'cart' });
          }
        }),
      ),
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private customCheckoutService: CustomCheckoutService,
    private environmentService: EnvironmentService,
    private routingService: RoutingService,
  ) {}

  ngrxOnRunEffects(resolvedEffects$: Observable<EffectNotification>): Observable<EffectNotification> {
    return iif(() => this.environmentService.isPlatformBrowser, resolvedEffects$, EMPTY);
  }
}
